import { DirectSignupFiltersFormType } from '../schemas/filtersSchema';

/**
 * Determines if a PCP (primary care physician info) is required based on the payment method.
 * @param paymentMethod The payment method to check.
 * @returns true if a PCP is required, false otherwise.
 */
export const isPCPRequired = (paymentMethod: DirectSignupFiltersFormType['paymentMethod']): boolean => {
  if (paymentMethod.type === 'insurance') {
    if (paymentMethod.insuranceData.insuranceType === 'Medicaid') {
      return true;
    }
    return paymentMethod.insuranceData.physicianOrderRequired || false;
  }

  return false;
};
